import React, { useState } from 'react';
import PropTypes from 'prop-types';
// Import Shared Components
import { Modal, ActionBar, ButtonGroup, Input, Loader } from 'shared-components';
// Import Shared Utils
import { post } from 'shared-components/src/utils/http';
// Import Global Components
import Heading from '../../../../components/Heading';
import Alert from '../../../../components/Alert';
import Text from '../../../../components/Text';
import CancelButton from '../../../../components/CancelButton';
import SubmitButton from '../../../../components/SubmitButton';
// Import Global Layouts
import Form from '../../../../layouts/Form';
import InputRow from '../../../../layouts/InputRow';
import InputGroup from '../../../../layouts/InputGroup';
// Import Translations
import { profileEn } from '../../../../i18n/profile';
// Import Local Layouts
import PinModal from '../../layouts/PinModal';

// Sensitive-data mints can require a fresh password confirmation (step-up)
export const isStepUpRequiredError = error =>
  Boolean(error) && error.code === 'step_up_required';

export const reverifyPassword = password =>
  post('/api/v1/cardholder_portal/cardholder/reverify_password', { password });

const PasswordConfirmModal = ({ onConfirm, onCancel, error }) => {
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const page = 'profile';

  const handleSubmit = async e => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await onConfirm(password);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal>
      <PinModal>
        {error && (
          <Alert
            alert={error}
            alertFor="confirm-password"
            page={page}
            type="danger"
          />
        )}
        <Heading
          page={`${page}-confirm-password`}
          heading={profileEn[`${page}-confirm-password-heading`]}
        />
        <Text
          text={profileEn[`${page}-confirm-password-text`]}
          textFor="confirm-password"
          page={page}
        />
        <Form onSubmit={handleSubmit}>
          <InputRow>
            <InputGroup
              label={profileEn[`${page}-password-label`]}
              labelFor="confirm-password"
              page={page}
            >
              <Input
                value={password}
                onChange={e => setPassword(e.target.value)}
                data-testid="confirm-password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
              />
            </InputGroup>
          </InputRow>
          {submitting && <Loader />}
          <ActionBar>
            <ButtonGroup reverse>
              <SubmitButton disabled={submitting} />
              <CancelButton
                disabled={submitting}
                onClick={e => {
                  e.preventDefault();
                  onCancel(e);
                }}
              />
            </ButtonGroup>
          </ActionBar>
        </Form>
      </PinModal>
    </Modal>
  );
};

PasswordConfirmModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  error: PropTypes.string,
};

PasswordConfirmModal.defaultProps = {
  error: null,
};

export default PasswordConfirmModal;
